import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import StyleTwoSectionTitle from './StyleTwoSectionTitle'

export class StyleTwoGuide extends Component {
  static propTypes = {
    styleTwo: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    let { itemsData } = this.props;
    return (
      <div className="style-two-style-two-guide" style={{ height: `${itemsData.height}`, background: `url(${itemsData.totalbackImg}) no-repeat` }}>
        <a name={itemsData.name}><StyleTwoSectionTitle isColorW={false} Data={itemsData} /></a>
        <div className='guide_content_box'>
          <img src={itemsData.subtitleImg} alt="" />
          <div className='posi_left_box flex_row'>
            <div className='posi_left_title'>{itemsData.subtitleList[0].title}</div>
            <div className='posi_left_content'>
              <div className='direction_box flex_row'>
                <div className='direction_title'>就业方向</div>
                <div className='direction_content'>{itemsData.subtitleList[0].direction}</div>
              </div>
              <div className='diff_box flex_row'>
                <div className='diff_title'>备考难度</div>
                <div className='diff_content'>
                  {itemsData.subtitleList[0].diffData && itemsData.subtitleList[0].diffData.map(item => <img src={item.url} alt="" key={item.id} />)}
                </div>
              </div>
            </div>
          </div>
          <div className='posi_right_box flex_row'>
            <div className='posi_right_content'>
              <div className='direction_box flex_row'>
                <div className='direction_title'>就业方向</div>
                <div className='direction_content'>{itemsData.subtitleList[1].direction}</div>
              </div>
              <div className='diff_box flex_row'>
                <div className='diff_title'>备考难度</div>
                <div className='diff_content'>
                  {itemsData.subtitleList[1].diffData && itemsData.subtitleList[1].diffData.map(item => <img src={item.url} alt="" key={item.id} />)}
                </div>
              </div>
            </div>
            <div className='posi_right_title'>{itemsData.subtitleList[1].title}</div>
          </div>

          <div className='chart_box flex_row'>
            <div className='chart_item'></div>
            <div className='chart_item'></div>
            <div className='chart_item'></div>
          </div>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    styleTwo: state.styleTwo,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StyleTwoGuide);



// WEBPACK FOOTER //
// ./src/features/style-two/StyleTwoGuide.js